import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Inbox, Check, X } from "lucide-react";

const STATUS = { pending: "Te keuren", accepted: "Goedgekeurd", rejected: "Afgekeurd" };

export const ReceivedWorkProducts = ({ transfers, canReview, reload }) => {
  if (!transfers.length) return null;
  const review = async (t, accepted) => {
    try {
      await api.post(`/transfers/${t.id}/review`, { accepted });
      toast.success(accepted ? "Input goedgekeurd" : "Input afgekeurd");
      reload();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Keuren mislukt");
    }
  };
  return (
    <div className="mt-5" data-testid="received-work-products">
      <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2 flex items-center gap-1.5">
        <Inbox className="h-3.5 w-3.5" /> Ontvangen werkproducten ({transfers.length})
      </div>
      <ul className="space-y-1.5">
        {transfers.map((t) => (
          <li key={t.id} className={`border-l-2 px-3 py-2 text-sm bg-zinc-50 ${t.status === "pending" ? "border-amber-500" : t.status === "accepted" ? "border-emerald-600" : "border-red-600"}`} data-testid="received-transfer-item">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-medium">{t.work_product_name}</div>
                <div className="text-[11px] text-zinc-500">van {t.from.label} · {t.from.node_name} · {t.sent_by}</div>
                {t.description && <p className="text-[11px] text-zinc-700 mt-1 whitespace-pre-line border-l border-zinc-300 pl-2" data-testid="received-transfer-description">{t.description}</p>}
              </div>
              <span className="font-mono text-[10px] uppercase shrink-0" data-testid="received-transfer-status">{STATUS[t.status]}</span>
            </div>
            {t.status === "pending" && canReview && (
              <div className="flex gap-2 mt-2">
                <Button size="sm" className="rounded-none h-7 bg-zinc-900" onClick={() => review(t, true)} data-testid="accept-transfer-button">
                  <Check className="h-3.5 w-3.5 mr-1" /> Getest en goed bevonden
                </Button>
                <Button size="sm" variant="outline" className="rounded-none h-7 text-red-700" onClick={() => review(t, false)} data-testid="reject-transfer-button">
                  <X className="h-3.5 w-3.5 mr-1" /> Afkeuren
                </Button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
